var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.notSaved || _vm.dataChanged ? _vm.internalTooltip : _vm.tooltip),expression:"notSaved || dataChanged ? internalTooltip : tooltip"}],staticClass:"button button-save",class:{
		'is-busy': _vm.isAnimating,
		'buttonRed': _vm.notSaved,
		disabled: _vm.isDisabled,
	},attrs:{"type":"button"},on:{"click":_vm.onClick}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.buttonText)+" ")],{"buttonText":_vm.buttonText,"isAnimating":_vm.isAnimating,"isDisabled":_vm.isDisabled,"onClick":_vm.onClick})],2)}
var staticRenderFns = []

export { render, staticRenderFns }